import { createNamespacedHelpers } from 'vuex';
import { Button } from 'element-ui';
import listenChannel from '@/util/socket';
import ExpressNavbar from '@/components/shared/ExpressNavbar/ExpressNavbar.vue';

const authMapper = createNamespacedHelpers('global/auth');
const globalMapper = createNamespacedHelpers('global');
const trainerModelMapper = createNamespacedHelpers('trainer/model');
const detectorModelMapper = createNamespacedHelpers('detector/model');
const historyMapper = createNamespacedHelpers('history');
const historyImageMapper = createNamespacedHelpers('history/image');
const historyModelMapper = createNamespacedHelpers('history/model');
const notificationMapper = createNamespacedHelpers('notification');
const advancedSettingMapper = createNamespacedHelpers('global/advancedSetting');

export default {
	components: {
		RetrainModal: () => import('@/views/history/RetrainModal/RetrainModal.vue'),
		History: () => import('@/layouts/HistoryLayout'),
		Toppage: () => import('@/layouts/TopPageLayout'),
		Trainer: () => import('@/layouts/TrainerLayout'),
		Detector: () => import('@/layouts/DetectorLayout'),
		Profile: () => import('@/layouts/ProfileLayout'),
		Setting: () => import('@/layouts/SettingLayout/SettingLayout.vue'),
		Auth: () => import('@/layouts/AuthLayout'),
		Model: () => import('@/layouts/ModelLayout'),
		[Button.name]: Button,
		ExpressNavbar,
	},
	data() {
		return {
			refreshing: false,
			registration: null,
			updateExists: false,
			retrainModalId: 'retrainModalId',
			historyImageModalId: 'ModalIdfromApp',
			height: document.documentElement.clientHeight,
			width: document.documentElement.clientWidth,
		};
	},

	computed: {
		...authMapper.mapState(['username']),
		...globalMapper.mapState(['spinner', 'namePage']),
		...historyMapper.mapState(['images']),
		...historyImageMapper.mapState(['retrainingImages']),
		...historyModelMapper.mapState(['model', 'trainable']),
		...advancedSettingMapper.mapState(['advancedSetting']),

		layout() {
			return this.$route.meta.namespace || 'auth';
		},

		noCheckBox: {
			get() {
				return this.$store.state.history.noCheckBox;
			},
			set(value) {
				this.$store.commit('history/UPDATE_NO_CHECKBOX', value);
			},
		},

		quickRetainDisabled() {
			return (
				this.retrainingImages?.length === 0 ||
				this.model === 'holes_patchcore.pytorch' ||
				this.model === 'opencv_holes'
			);
		},
		displayMode() {
			let mode = 'browser';
			const mqStandAlone = '(display-mode: standalone)';
			if (navigator.standalone || window.matchMedia(mqStandAlone).matches) {
				mode = 'standalone';
			}
			return mode;
		},
	},
	created() {
		document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
		if (navigator.serviceWorker) {
			navigator.serviceWorker.addEventListener('controllerchange', () => {
				if (this.refreshing) return;
				this.refreshing = true;
				window.location.reload();
			});
		}
	},

	async mounted() {
		if (process.env.VUE_APP_MODE === 'local') {
			const userName = process.env.VUE_APP_USER_NAME;
			this.connectToChannel(userName);
		}

		// listen to socket
		const updateModelCallback = (data) => {
			// call retrieveModels of trainer and detector
			this.$store.dispatch('trainer/model/retrieveModels', data);
			this.$store.dispatch('detector/model/retrieveModels', data);
			this.retrieveAllNotification({ username: this.username });
		};

		// this.getByUser({ userId: this.userInfo?.id })
		this.getCurrentDevice();
		listenChannel(this, this.username, updateModelCallback, 'training');
		window.addEventListener('resize', this.onScreenResize);

		if (this.username) await this.getUserInfo(this.username);
	},

	methods: {
		...trainerModelMapper.mapActions(['retrieveModels']),
		...detectorModelMapper.mapActions(['retrieveModels']),
		...historyImageMapper.mapActions(['retrain', 'closeOptionsImage']),
		...notificationMapper.mapActions(['retrieveAllNotification']),
		...advancedSettingMapper.mapMutations(['SET_CONTENT_ADVANCE_SETTING']),
		...advancedSettingMapper.mapActions(['getByUser', 'getCurrentDevice']),
		...authMapper.mapActions(['getUserInfo', 'login', 'connectToChannel']),

		async onQuickRetrain() {
			await this.retrain();
			this.$eventBus.$emit('force-update');
		},

		openRetrainModal() {
			this.closeOptionsImage();
			this.$store.commit('history/UPDATE_NO_CHECKBOX', true);
			this.$bvModal.show(this.retrainModalId);
		},
		showRefreshUI(e) {
			if (this.displayMode !== 'standalone') return;
			this.registration = e.detail;
			this.updateExists = true;
		},
		refreshApp() {
			this.updateExists = false;
			if (!this.registration || !this.registration.waiting) {
				return;
			}
			this.registration.waiting.postMessage('skipWaiting');
		},

		onScreenResize() {
			this.height = document.documentElement.clientHeight;
			this.width = document.documentElement.clientWidth;
		},
	},
};
